/**
 * @fileoverview A component which renders a container for the TreeActionsPortal depending on the
 * mode.
 *
 * @author Justin Mancusi (jmancusi@yext.com)
 */

import {TreeActionsMode} from '/src/com/yext/sitesgitstorm/js/src/editor/tree/constants';

/**
 * A component which renders an action container which depends on the mode.
 * @param {{mode: string, rowRef: {current: *}}} props
 * @return {React.ReactNode}
 */
export const TreeActionsContainer = (
  {
    mode,
    rowRef,
  },
) => {
  switch (mode) {
    case TreeActionsMode.BUTTON: {
      return <div className={'tree-actions'}>
        <div className={'tree-actions__anchor--button'} ref={rowRef}/>
      </div>;
    }
    case TreeActionsMode.MENU: {
      return <div className={'tree-actions'}>
        <div className={'tree-actions__anchor--menu'} ref={rowRef}/>
      </div>;
    }
    default:
      return null;
  }
};
